export const FETCH_ABOUTME_START = "FETCH_ABOUTME_START";
export const FETCH_ABOUTME_SUCCESS = "FETCH_ABOUTME_SUCCESS";
export const FETCH_ABOUTME_FAIL = "FETCH_ABOUTME_FAIL";

export const FETCH_CURRICULUM_START = "FETCH_CURRICULUM_START";
export const FETCH_CURRICULUM_SUCCESS = "FETCH_CURRICULUM_SUCCESS";
export const FETCH_CURRICULUM_FAIL = "FETCH_CURRICULUM_FAIL";

export const FETCH_SKILLS_START = "FETCH_SKILLS_START";
export const FETCH_SKILLS_SUCCESS = "FETCH_SKILLS_SUCCESS";
export const FETCH_SKILLS_FAIL = "FETCH_SKILLS_FAIL";
